// File: e1c/src/components/content_editor/YesNoBlock.js
// HOLISTIC REFACTOR V4.4: Remove local state for props, bind directly to props.

import React, { useCallback, useMemo } from 'react'; // Removed useState, useEffect
import {
    Box,
    Grid,
    IconButton,
    Paper,
    TextField,
    Typography,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const YesNoBlock = React.memo(({ id, question: questionProp, options: optionsProp = {}, onChange, onDelete }) => {

    // Memoize options derived from props for stability and default values.
    const memoizedOptions = useMemo(() => ({
        yesLabel: optionsProp.yesLabel ?? 'Yes',
        noLabel: optionsProp.noLabel ?? 'No',
        yesValue: optionsProp.yesValue || 'yes',
        noValue: optionsProp.noValue || 'no',
    }), [optionsProp.yesLabel, optionsProp.noLabel, optionsProp.yesValue, optionsProp.noValue]);

    // --- onChange Handlers ---
    const handleQuestionChange = useCallback((event) => {
        if (onChange) {
            onChange({ question: event.target.value });
        }
    }, [onChange]);

    const handleYesLabelChange = useCallback((event) => {
        if (onChange) {
            onChange({ options: { yesLabel: event.target.value } });
        }
    }, [onChange]);

    const handleNoLabelChange = useCallback((event) => {
        if (onChange) {
            onChange({ options: { noLabel: event.target.value } });
        }
    }, [onChange]);

    const handleDeleteClick = useCallback(() => {
        if (onDelete) { onDelete(id); }
    }, [id, onDelete]);

    // --- Render Logic ---
    // Input values are now bound DIRECTLY to props (questionProp) or derived props (memoizedOptions).
    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2, position: 'relative', '&:hover .delete-button': { opacity: 1 } }}>
            <IconButton
                className="delete-button" aria-label="delete block" onClick={handleDeleteClick} size="small"
                sx={{ position: 'absolute', top: 8, right: 8, opacity: 0, transition: 'opacity 0.2s', zIndex: 1 }}
            >
                <DeleteOutlineIcon />
            </IconButton>
            <TextField
                fullWidth
                variant="outlined"
                label={`Yes/No Question Text (ID: ${id})`}
                value={questionProp || ''} // Bind value directly to prop
                onChange={handleQuestionChange} // Use stable handler
                multiline
                minRows={2}
                sx={{ mb: 2 }}
            />
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Label for 'Yes' Option"
                        value={memoizedOptions.yesLabel} // Bind value directly to derived prop
                        onChange={handleYesLabelChange} // Use stable handler
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Label for 'No' Option"
                        value={memoizedOptions.noLabel} // Bind value directly to derived prop
                        onChange={handleNoLabelChange} // Use stable handler
                        size="small"
                    />
                </Grid>
            </Grid>
             {/* Preview Section - Also uses derived props now */}
             <Box sx={{ mt: 2, p: 1.5, backgroundColor: 'grey.100', borderRadius: '4px' }}>
                <Typography variant="caption" display="block" sx={{ mb: 1 }}>Patient View Preview:</Typography>
                <FormControl component="fieldset" disabled>
                    <RadioGroup row name={`preview-${id}`} >
                        <FormControlLabel value={memoizedOptions.yesValue} control={<Radio size="small" />} label={memoizedOptions.yesLabel} />
                        <FormControlLabel value={memoizedOptions.noValue} control={<Radio size="small" />} label={memoizedOptions.noLabel} />
                    </RadioGroup>
                </FormControl>
            </Box>
        </Paper>
    );
});

export default YesNoBlock;